export enum ZIndex {
  BASE = 0,
  TOOLTIP = 100,
  BACKGROUND_OVERLAY = 900,
  VIDEO_OVERLAY = 1000,
  VIDEO_END_OVERLAY = 1010,
  HEADER = 1020,
  POPUP = 1025,
  DRAWER = 1030,
  PAGE_ACTION = 1035,
  MODAL_BACKGROUND = 1040,
  MODAL = 1050,
}
